export default __webpack_public_path__ + "static/Aeonik-ThinItalic-a160ecb4a72268085e3e6352d8423dea.otf";